import React, { Component } from 'react'
import _ from 'lodash'
import { constants } from '../../constants/constants'
import { apiConstants } from '../../constants/apiConstants'
import { shareConstants } from '../../constants/shareConstants'
import Notifications from './Notifications'
import Settings from './Settings'
import MobileSideNavBar from './MobileSideNavBar'
import { isUserHasAccess, isCorpOrGoPayUser } from '../../helper'
import { Message } from '@paypalcorp/worldready-react'
import { sharePermissionConstants } from '../../constants/sharePermissionConstants'

class Header extends Component {
  constructor(props, context) {
    super(props, context)
    this.state = {
      showUserDetails: false,
      showNotifications: false,
      showSettings: false,
      renderSettings: false,
      renderNotification: false,
      notifications: [
        {
          name: 'Dharani Shared a file with you',
          date: 'March 13, 2019 10:00 AM',
        },
        {
          name: 'Dharani Shared a file with you',
          date: 'March 13, 2019 10:00 AM',
        },
        {
          name: 'Dharani Shared a file with you',
          date: 'March 13, 2019 10:00 AM',
        },
        {
          name: 'Dharani Shared a file with you',
          date: 'March 13, 2019 10:00 AM',
        },
        {
          name: 'Dharani Shared a file with you',
          date: 'March 13, 2019 10:00 AM',
        },
        {
          name: 'Dharani Shared a file with you',
          date: 'March 13, 2019 10:00 AM',
        },
      ],
    }
    this.userRef = React.createRef()
  }

  componentDidMount() {
    document.addEventListener('click', this.handleOutsideClick, false)
    document.addEventListener('keydown', this.handleKeydown, false)
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.handleKeydown, false)
  }

  handleOutsideClick = (e) => {
    const { showUserDetails } = this.state
    if (showUserDetails) {
      if (this.userRef.current.contains(e.target)) {
        return
      }
      this.setState({ showUserDetails: false })
    }
  }

  handleKeydown = (event) => {
    const { keyCode } = event
    const { showUserDetails } = this.state
    if (keyCode === 27) {
      if (showUserDetails) {
        this.setState({ showUserDetails: false })
      }
    }
  }

  logoutUser = async () => {
    this.setState({ showUserDetails: false })
    this.props.logoutUser()
  }

  toggleNotificationBox = () => {
    this.setState((prevState) => {
      return {
        showNotifications: !prevState.showNotifications,
      }
    })
  }

  toggleSettingsBox = () => {
    this.setState((prevState) => {
      return {
        showSettings: !prevState.showSettings,
      }
    })
  }

  navigateMenu = (key) => {
    const { user } = this.props
    if (key === 'help') {
      this.props.history.push(`${apiConstants.URLPrefix}${apiConstants.Help}`)
      this.props.setActiveMenu(key)
    } else if (key === 'share_request') {
      this.props.history.push(
        `${apiConstants.URLPrefix}${apiConstants.SharePermissionRequest}`,
      )
      this.props.setActiveMenu(key)
    } else if (key !== 'home') {
      this.props.setActiveMenu(key)
      this.props.history.push(`${apiConstants.URLPrefix}/${key}`)
    } else {
      this.props.setActiveMenu('home')
      this.props.history.push(`${apiConstants.URLPrefix}`)
      this.props.actions.setBaseFolder('/')
      this.props.actions.setUserPermissionForFolder(
        isCorpOrGoPayUser(user)
          ? shareConstants.FilePermissions.readWriteExecute
          : shareConstants.FilePermissions.read,
      )
    }
    this.props.actions.setLimit(apiConstants.Limit)
    this.props.actions.setPageNo(apiConstants.PageNo)
    this.props.actions.setSortBy(apiConstants.SortBy)
    this.props.actions.setSortType(apiConstants.SortType)
    this.props.actions.setStartDate(0)
    this.props.actions.setEndDate(0)
    this.props.actions.setBaseFolder('/')
    this.props.actions.setFileDetails({})
    this.props.actions.setTree({
      total: 0,
      results: [],
    })
    this.props.actions.setFileListFromResponse({})
  }

  enableUserInfo = (showUserDetails) => {
    this.setState({ showUserDetails })
  }

  checkMenuVisibility = (item) => {
    const { user, deployEnv } = this.props
    if (isUserHasAccess(user, constants.Users.user, deployEnv).hasAccess) {
      return item.display
    }
    return false
  }

  renderHeaderMenu = () => {
    const { activeMenu, user } = this.props
    const activeMenuLink =
      activeMenu === ''
        ? this.props.setActiveMenuFromPath(this.props.location.pathname)
        : activeMenu
    return (
      <ul className="vx_globalNav-list">
        {constants.HeaderMenu.map((item) => {
          return (
            this.checkMenuVisibility(item) && (
              <li
                className={`${
                  activeMenuLink === item.key ? 'vx_isActive' : ''
                }`}
                key={item.key}
              >
                <a
                  id={`header-${item.key}`}
                  name={`header-${item.key}`}
                  className="vx_globalNav-links pointer"
                  data-pa-pgrp={`dropzone:${user.accType}`}
                  data-pa-page={`dropzone:${item.key}:${user.accType}`}
                  data-pa-click={item.key}
                  onClick={() => this.navigateMenu(item.key)}
                >
                  <Message id={`header.${item.localizeId}`} />
                </a>
              </li>
            )
          )
        })}
      </ul>
    )
  }

  renderHelpMenu = () => {
    const { activeMenu, user } = this.props
    return (
      <li
        className={`${activeMenu === 'help' ? 'vx_isActive' : ''}`}
        key="help"
      >
        <a
          id={`header-help`}
          name={`header-help`}
          className="vx_globalNav-links pointer"
          data-pa-pgrp={`dropzone:${user.accType}`}
          data-pa-page={`dropzone:help:${user.accType}`}
          data-pa-click="help"
          onClick={() => this.navigateMenu('help')}
        >
          <Message id="header.helpMenu" />
        </a>
      </li>
    )
  }

  renderShareRequestNotificationIcon = () => {
    return (
      <li
        className="share_request_notification_icon-container"
        key="share_request_notification"
      >
        <div
          className="share_request_notification_icon tooltip"
          onClick={() => this.navigateMenu('share_request')}
        >
          <span className="share__permission_header_logo_tooltiptext ppvx_text--md">
            {sharePermissionConstants.permissionRequestList.headerIcon.title}
          </span>
          {sharePermissionConstants.permissionRequestList.headerIcon.icon}
        </div>
      </li>
    )
  }

  renderHeaderOptions = () => {
    const { renderNotification, renderSettings } = this.state
    const { user } = this.props
    return (
      <ul className="vx_globalNav-list vx_globalNav-list_secondary">
        {renderNotification && this.renderNotificationIcon()}
        {renderSettings && this.renderSettingsIcon()}
        {this.renderHelpMenu()}
        {user.accType === constants.CorpUser &&
          this.renderShareRequestNotificationIcon()}
        {this.renderUserInfo()}
      </ul>
    )
  }

  renderNotificationIcon = () => {
    const { showNotifications, notifications } = this.state
    return (
      <li className="vx_hidden-phone" data-autodisplay="false">
        <a
          id="header-notifications"
          className="vx_globalNav-svgIcon vx_globalNav-link_notifications vx_isCritical js_notifications js_notificationDesktopBtn cw_popover-trigger pointer"
          onClick={() => this.toggleNotificationBox()}
        >
          <span className="ppvx_icon ppvx_icon--size_lg ppvx_icon-notification header__icon--color" />
          {notifications.length > 0 && (
            <span className="vx_notificationCount js_notificationCount">
              {notifications.length}
            </span>
          )}
          <span className="vx_a11yText">Notifications</span>
        </a>

        {showNotifications && (
          <Notifications
            {...this.props}
            notifications={notifications}
            toggleNotificationBox={() => this.toggleNotificationBox()}
          />
        )}
      </li>
    )
  }

  renderSettingsIcon = () => {
    const { showSettings } = this.state
    return (
      <li>
        <a
          id="header-settings"
          name="header-settings"
          className="vx_globalNav-svgIcon vx_globalNav-link_settings pointer"
          onClick={() => this.toggleSettingsBox()}
        >
          <span className="ppvx_icon ppvx_icon--size_lg ppvx_icon-settings header__icon--color" />
          <span className="vx_a11yText">Settings</span>
        </a>
        {showSettings && (
          <Settings
            {...this.props}
            toggleSettingsBox={() => this.toggleSettingsBox()}
          />
        )}
      </li>
    )
  }

  renderLogout = () => {
    const { user } = this.props
    return (
      <li role="user-logout" className="header__user-logout">
        <div
          id="user-logout"
          data-pa-pgrp={`dropzone:${user.accType}`}
          data-pa-page={`dropzone:logout:${user.accType}`}
          data-pa-click="logout"
          onClick={() => {
            this.logoutUser()
          }}
        >
          <div className="header__user-logout--link">
            <Message id="header.logout" />
          </div>
        </div>
      </li>
    )
  }

  renderUserProfile = () => {
    return (
      <span
        className="ppvx_icon ppvx_icon--size_lg ppvx_icon-user header__user-icon"
        onClick={() => this.enableUserInfo(true)}
      />
    )
  }

  renderUserInfo = () => {
    const { showUserDetails } = this.state
    const { user } = this.props
    const isCorpUser = isCorpOrGoPayUser(user)
    return (
      <li
        className={`ppvx_overflow-menu ${
          isCorpUser
            ? 'header__user-icon-container-corp'
            : 'header__user-icon-container'
        }`}
        ref={this.userRef}
      >
        {this.renderUserProfile()}
        {showUserDetails && (
          <ul
            className="ppvx_overflow-menu__list header__user-icon-details--content"
            role="menu"
            aria-label="Overflow"
            id="userDetailsMenu"
          >
            <li role="username">
              <div className="header-user-name" id="username">
                <Message id="header.greeting" name={user.displayname} />
              </div>
            </li>
            {this.renderLogout()}
          </ul>
        )}
      </li>
    )
  }

  render() {
    const { isUserLoggedout } = this.props
    return (
      <div
        className="vx_globalNav-main globalNav-main js_globalNavView"
        role="banner"
        data-testid="header-view"
      >
        <div className="contextual-help-app" />
        <div className="vx_globalNav-container">
          <a
            id="header-ppLogo"
            name="header-logo"
            className="vx_globalNav-brand_desktop header__logo"
            onClick={() => this.navigateMenu('home')}
          >
            <div className="ppvx_text--md header__logo-text">DropZone</div>
            <span className="vx_a11yText">All Files</span>
          </a>
          {isUserLoggedout ? '' : <MobileSideNavBar {...this.props} />}
          {isUserLoggedout ? (
            ''
          ) : (
            <div className="vx_globalNav-navContainer">
              <nav className="vx_globalNav-nav" role="navigation">
                {this.renderHeaderMenu()}
                {this.renderHeaderOptions()}
              </nav>
            </div>
          )}
        </div>
      </div>
    )
  }
}

export default Header
